if (!customElements.get('load-more')) {
  customElements.define(
    'load-more',
    class LoadMore extends HTMLElement {
      constructor() {
        super();
        this.onClick = this.onClick.bind(this);
      }

      connectedCallback() {
        this.button = this.querySelector('[data-load-more]');
        this.button?.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.button?.removeEventListener('click', this.onClick);
      }

      // Appends the next page of products to the grid; the link still works without JS.
      async onClick(event) {
        event.preventDefault();
        const url = new URL(this.button.href);
        url.searchParams.set('section_id', this.dataset.sectionId);
        this.button.setAttribute('aria-busy', 'true');

        try {
          const response = await fetch(url);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const grid = document.getElementById('product-grid');
          const items = Array.from(html.querySelectorAll('#product-grid > .grid__item'));

          grid.append(...items);
          if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(grid);
          items[0]?.querySelector('a')?.focus({ preventScroll: true });

          const next = html.querySelector('load-more');
          next ? this.replaceWith(next) : this.remove();
        } catch {
          window.location.assign(this.button.href);
        }
      }
    }
  );
}
